import { memo, useRef } from "react";
import { Typography, Card, Badge, Flex } from "antd";
import { MediaStatus } from "../../components/MediaStatusComponent";
import { getVideoTypeColor, getVideoTypeLabel } from "../helpers";
import dayjs from "dayjs";
import { useTranslate } from "#src/hooks";
import { Video, MetadataAsset } from "../types";
import { VideoCardToolbar } from "./VideoCardToolbar";
import { VideoItem } from "./VideoItem";
import { VideoMetadataAssetTabs } from "./VideoMetadataAssetTabs";

export type VideoCardProps = {
  video: Video;
};

export const VideoCard = memo(({ video }: VideoCardProps) => {
  const t = useTranslate();
  const title = (video.metadata.assets as MetadataAsset[] | undefined)
    ?.map((x) => x.name)
    .join(", ");
  const url = video.url;
  const statusMode = Boolean(video.status);
  const isCompact = statusMode;

  const linkRef = useRef<HTMLAnchorElement>(null);

  return (
    <Card
      size="small"
      title={
        <>
          {video.status ? (
            <MediaStatus status={video.status} label={title} />
          ) : (
            title
          )}
        </>
      }
      styles={{ header: { fontSize: 18 } }}
      extra={<VideoCardToolbar videoId={video.id} linkRef={linkRef} />}
    >
      {!isCompact && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 10,
            marginTop: -10,
          }}
        >
          <a
            ref={linkRef}
            rel="noreferrer"
            target="_blank"
            style={{ display: "none" }}
            download={video.url}
            href={url}
          >
            {t("media.batches.list.download")}
          </a>
          <VideoItem url={url} />
        </div>
      )}
      <Card.Meta
        style={{ marginBottom: -10 }}
        description={
          <>
            <Flex justify="space-between">
              <Badge
                style={{ fontWeight: "bold" }}
                color={getVideoTypeColor(video.metadata.type)}
                text={getVideoTypeLabel(video.metadata.type)}
              />
              <Typography.Text>
                {dayjs(video.metadata.date).format("dddd LL")}
              </Typography.Text>
            </Flex>
            <VideoMetadataAssetTabs
              assets={video.metadata.assets as MetadataAsset[] | undefined}
            />
          </>
        }
      />
    </Card>
  );
});

VideoCard.displayName = "VideoCard";
